export type EmailCode = {
    email: string,
    code: string,
    expires: number,
    created: number,
}

export const authorized_admins = ['forrestmilner@gmail.com', 'susanmilner1969@gmail.com', 'milner.christopher@gmail.com', 'cmilner@oakleaf.com', 'cmilner@yahoo.com']

export type Attendee = {
    lastName: string,
    firstName: string,
    ageOnApril24: string,
    registeredForRE: boolean,

    okToPhotograph: boolean,
    responsibleAdult: string,

    vegetarian: boolean,
    vegan: boolean,
    glutenFree: boolean,
    dairyFree: boolean
}

export type Payment = {
    amount: number,
    date: number, // ms since epoch
    signature: string, // to confirm this payment was legitimate.
}

export type Registration = {
    email: string,
    lastName: string,
    firstName: string,
    phoneNumber: string,
    preferredContactMethod: string,

    attendees: Attendee[],
    additionalDietaryNeeds: string,

    sleepingArrangementChoice: string,
    cabinSharing: string,
    sleepingArrangementsComments: string,

    abilityToPay: "" | "I can pay more than my fair share" | "I can pay my fair share" | "I can pay a reduced rate" | "Please waive my registration fees" | "Specialized Fees",
    waiverReason: string,
    donationAmount: number,

    registrationComments: string,
    rideSharing: string,
    liabilityWaiverAccepted: boolean,
    liabilityWaiverAcceptedBy: string
}

export type Payments = {
    email: string,
    payments: Payment[]
}


export type AdminSummary = {
    registrationCount: number,
    registrations: {
        max: number,
        completed: number,
        inProgress: number,
    }
    owedRefund: string[];
}